export default {"src":"/_next/static/media/ico_play.8b5181e4.svg","height":50,"width":50,"blurWidth":0,"blurHeight":0};